import React, { useRef, useState, useCallback } from 'react';
import './WinnersStripContainer.css';
import classNames from 'classnames';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { WinnersStrip } from '../WinnersStrip';
import { useCallbackOnInitAndResizeHook } from '../../../../../shared/src/hooks/use-callback-on-init-and-resize.hook';

export const WinnersStripContainer = ({
    className,
    showStripsGridUI,
}) => {
    const [wrapperWidth, setWrapperWidth] = useState(0);
    const wrapperRef = useRef(null);
    const { t } = useTranslations();

    const updateWrapperWidth = useCallback(() => {
        setWrapperWidth(wrapperRef?.current?.offsetWidth);
    }, [wrapperRef, setWrapperWidth]);
    useCallbackOnInitAndResizeHook({ callback: updateWrapperWidth });

    const wrapperClasses = classNames({
        'winners-strip__wrap': true,
        'winners-strip__wrap--strips-grid-ui': showStripsGridUI,
        [className]: !!className,
    });

    return <div className={wrapperClasses} ref={wrapperRef}>
        <div className="winners-strip__title">{t('winners')}</div>
        <WinnersStrip parentWidth={wrapperWidth} />
    </div>;
};
